var drawer = function () {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',
      selectorUpdateQty: '[data-update-qty]'
    };


    var toggleccessibility = function (event) {
      // will need to find aria-expanded if clicked from the button
      if (event.getAttribute('aria-expanded') === null)
      {
        event = $('.cart-link')[0];
      }
      
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };

    var originalFocus;
  
    var openDrawer = function (trigger) {
      var target = document.getElementById(trigger.getAttribute('aria-controls'));
      target.classList.add(settings.activeClass);
      document.documentElement.style.overflow = 'hidden';
      toggleccessibility(trigger);

      setTimeout(function () {
        target.classList.add(settings.visibleClass);

        // Focus management for opened drawer
        trapFocusInDrawer(target);
        
        // Set focus to a specific element inside the drawer once it's open and visible
        var continueShoppingButton = target.querySelector('#continue-shopping-button');

        if (continueShoppingButton) {
          continueShoppingButton.focus();
        } else {
          console.log('Focus target "Continue Shopping" not found.');
        }
        
      }, settings.speedOpen);
    };

    var closeDrawer = function (event) {
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
      closestParent.classList.remove(settings.visibleClass);
      document.documentElement.style.overflow = '';
      toggleccessibility(childrenTrigger);
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);

      // return focus to the element that had it before the drawer was opened
      if (originalFocus && originalFocus.focus) {
        originalFocus.focus(); // Return focus to the original element
      }
    };

    var trapFocusInDrawer = function(drawerElement) {
      var focusableElements = drawerElement.querySelectorAll('a, button, input, select, [tabindex]:not([tabindex="-1"])');
      var firstFocusableElement = focusableElements[0];
      var lastFocusableElement = focusableElements[focusableElements.length - 1];

      drawerElement.addEventListener('keydown', function(e) {
        
        if (e.key === 'Tab' || e.keyCode === 9) {
          if (e.shiftKey) { // Shift + Tab
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else { // Tab
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });
    };

  
    var clickHandler = function (event) {
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose),
        updateQty = toggle.closest(settings.selectorUpdateQty);

      var isAddToCart = false;
      if (open != null && open.getAttribute('aria-expanded') === null)
      {
        isAddToCart = true;
      }

      if (open) { 
        originalFocus = open; // capture the original focus, and return to it in the closeDrawer() function
        openDrawer(open); 
      }
      if (close) { closeDrawer(close); }
      if (updateQty) { updateCartQuantity(updateQty); }
      if (!isAddToCart)
      {
        if (open || close) { event.preventDefault(); }
      }
    };


    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
      if (event.key === 'Enter' || event.keyCode === 13) {
        if (event.srcElement.className == 'input-field cart-item-quantity-display') {
          if (checkInputAsValid(event)) {
            updateCartQuantity(event.srcElement);
          }
        }
      }
    };






    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);

  
};

drawer();

var updateCartQuantity = function(e) {

  var action, inventory, message, newQuantity, oldQuantity, productPrice, productQuantity, productRow, productTitle, title, variant, isGiftCard, maxInventory;
  
  productRow = $(e).parents('div.cart-item');
  productTitle = productRow.find('.cart-title').text().trim();
  productPrice = productRow.find('.cart-item-price').find('.money')[0].innerText;
  productPriceTotal = productRow.find('.cart-item-total').find('.money');
  productQuantity = productRow.find('.cart-item-quantity-display');
  
  if (productTitle.toLowerCase().includes("gift card")) { 
    isGiftCard = true; 
  } else { 
    isGiftCard = false; }
  
  variant = productRow.data('variant');
  inventory = parseInt(productRow.find('.cart-item-quantity').data('max'), 10);
  oldQuantity = parseInt(productQuantity.val(), 10);

  if (isNaN(oldQuantity)) {
    oldQuantity = 0;
  }
  
  if ($(e).hasClass('cart-item-quantity-display')) {
    if (oldQuantity >= inventory &&!isGiftCard) {
      oldQuantity = inventory;
      maxInventory = true;
    }
    newQuantity = Math.max(oldQuantity, 0);
  }
  else if ($(e).hasClass('cart-item-increase')) {
    newQuantity = oldQuantity + 1;
  } else {
    newQuantity = oldQuantity <= 1 ? 0 : oldQuantity - 1;
  }
  if (newQuantity >= inventory && !isGiftCard) {
    maxInventory = true;
    newQuantity = inventory;
    /*title = this.context.cart.notAvailableText;
    message = this.context.cart.stockLevelText.replace('** stock_count **', inventory);
    action = "<span class='button dismiss'>" + this.context.cart.okayText + "</span>";
    return this.openModal(title, message, action);*/
  }
  if (maxInventory && productRow.find('.max-inventory').hasClass('hidden')) {
    productRow.find('.max-inventory').removeClass('hidden');
  }
  else if (!maxInventory && !productRow.find('.max-inventory').hasClass('hidden')) {
    productRow.find('.max-inventory').addClass('hidden');
  }
  productRow.find('.cart-item-quantity-display').val(newQuantity); // put this here
  var updatedPrice = toPrice(productPrice) * newQuantity;
  productPriceTotal[0].innerText = '$ ' + (updatedPrice / 100).toFixed(2);
  // now update the entire total
  updateTotalPrice();
  var newTotalQty = updateItems();

  $('.cart-count')[0].innerText = newTotalQty;
  return; //productRow.find('.cart-item-quantity-display').val(newQuantity); // move this so that it calculates
};

var qtyInputOnFocus;

var getQtyInputOnFocus = function () {
  var productRow = $(event.srcElement).parents('div.cart-item');
  var productQuantity = productRow.find('.cart-item-quantity-display');

  qtyInputOnFocus = parseInt(productQuantity.val(), 10);
}

var checkInputAsValid = function(event) {
  var productRow = $(event.srcElement).parents('div.cart-item');
  var productQuantity = productRow.find('.cart-item-quantity-display');

  var newQty = parseInt(productQuantity.val(), 10);

  if (isNaN(newQty)) {
    productRow.find('.cart-item-quantity-display').val(qtyInputOnFocus);
    // 
    return false;
  }
  return true;
}

var updateQtyInputs = function() {
  if (checkInputAsValid(event)) {
    updateCartQuantity(event.srcElement);
  }
}

var updateTotalPrice = function() {
  var totalCartPrice = $('.cart-price').find('.money');
  var updatedTotalCartPriceInCents = 0; // work in cents
  var prices = $('.cart-item').find('.cart-item-total').find('.money');

  for (let i = 0; i < prices.length; i++) {
    updatedTotalCartPriceInCents += toPrice(prices[i].innerText);
  }

  totalCartPrice[0].innerText = '$ ' + (updatedTotalCartPriceInCents / 100).toFixed(2);  // convert to dollars for display
  return updateFreeShippingProgress(updatedTotalCartPriceInCents);  // send in cents
}



var toPrice = function(p) {
  // this assumes the format of the price = '$ ' + price
  if (!p.startsWith('$ ')) {
    return Math.round(parseFloat(p) * 100);  // If it doesn't start with a dollar sign, parse it as a float and convert to cents
  }
  var priceInDollars = parseFloat(p.substring(2));  // Use substring(2) to remove both $ and space
  var priceInCents = Math.round(priceInDollars * 100);  // Convert to cents
  return priceInCents;
}


var updateItems = function () {
  // use this to return the total number of items in the cart as well
  var totalItems = 0;
  
  // get the data from each item in the cart
  var cartItemDiv = document.getElementById('cart__drawer_items');
  
  var cartItems = $(cartItemDiv).find('.cart-item');
  var updates = {};
  
  for (let i = 0; i < cartItems.length; i++) {
    var dataKey;
    var qtyItem = $(cartItems[i]).find('.cart-item-quantity-display');

    // note that if the item was added from this same page we can't get the cart item key, so use the variant instead
    if (cartItems[i].dataset.key != null) {
      dataKey = cartItems[i].dataset.key;
    }
    else {
      dataKey = cartItems[i].dataset.variant;
    }
    
    var dataValue = $(qtyItem).val();
    updates[dataKey] = dataValue;

    totalItems += ($(qtyItem).val() * 1);
  }

    jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
    updates
  });
  return totalItems;
}

var addItemToDrawer = function () {

  // iterate through the items already in the cart drawer, see if the item getting added to it is already there
  // if so, update the qty
  // if not, add it to the drawer
  var variantId, currentVariant; 
  var url = window.location.href;
  var productSelectOptions = document.querySelectorAll('#product-select-'+item.ProductID);
  // get the "no js" product select options, these include the variant id
  // check if this is a gift card
  if (url.includes('f2f-gift-card')) {
    var giftCardValue = document.querySelector(':checked + .input-checkbox-title').innerText;
    var productSelectOptions = document.querySelectorAll('#product-select-'+item.ProductID);
    for (var i = 0; i < productSelectOptions[0].length; i++) {
      if (productSelectOptions[0][i].innerText.includes(giftCardValue) 
          && !isNaN(productSelectOptions[0][i].value)) {
        variantId = productSelectOptions[0][i].value;
        break;
      }
    }
  }
  else {
    var sz, color;
    var productOptions = document.querySelectorAll('.product-options .inline-field-wrapper');
    for (var i = 0; i < productOptions.length; i++) {
      if (productOptions[i].querySelector('.input-field-title').innerText == "Size:") {
        sz = productOptions[i].querySelector(':checked + .input-checkbox-title').innerText;
      }
      if (productOptions[i].querySelector('.input-field-title').innerText == "Color:") {
        color = productOptions[i].querySelector(':checked + .input-checkbox-title').innerText;
      }
    }
    var szColor = sz + ' / ' + color;
    for (var i = 0; i < productSelectOptions[0].length; i++) {
      if (productSelectOptions[0][i].innerText.includes(szColor) 
          && !isNaN(productSelectOptions[0][i].value)) {
        variantId = productSelectOptions[0][i].value;
        break;
      }
    }
  }
  

  // check the variantId to see if it seems valid, if not try to find it in the select options
  if (variantId == null) {
    // wtf
    console.log('Cannot find variant for this item');
    return;
  }
  if (!isNaN(variantId)) {
    currentVariant = variantId;
  }
  else {
    var productSelectOptions = document.querySelectorAll('#product-select-'+item.ProductID);
    for (var i = 0; i < productSelectOptions[0].length; i++) {
      if (variantId.includes(productSelectOptions[0].value) 
          && !isNaN(productSelectOptions[0].value)) {
        currentVariant = productSelectOptions[0].value;
        break;
      }
    }
  }
  
  var currentQty = $('.product-quantity-input')[0].value;
  var cartItems = $(document.getElementById('cart__drawer_items')).find('.cart-item');
  var totalItems = 0;
  var alreadyInCart = false;
  
  for (let i = 0; i < cartItems.length; i++) {
    var dataKey, dataKeyVariant;
    var qtyItem = $(cartItems[i]).find('.cart-item-quantity-display');
    
    // note that if the item was added from this same page we can't get the cart item key, so use the variant instead
    if (cartItems[i].dataset.key != null) {
      dataKey = cartItems[i].dataset.key;
      dataKeyVariant = dataKey.split(':')[0];
    }
    else {
      dataKeyVariant = cartItems[i].dataset.variant;
    }


    if (dataKeyVariant == currentVariant)
    {
      // we have a match, update the qty
      alreadyInCart = true;
      var dataValue = $(qtyItem).val();
      var newValue = (dataValue * 1) + (currentQty * 1);

      $(qtyItem).val(newValue);
    }
    totalItems += ($(qtyItem).val() * 1);

    var itemPrice = (toPrice($(cartItems[i]).find('.cart-item-price').find('.money')[0].innerText) * 1);
    var newTotal = ($(qtyItem).val() * itemPrice / 100);
    $(cartItems[i]).find('.cart-item-total').find('.money')[0].innerText = '$ ' + newTotal.toFixed(2);
    break;
  }
  if (!alreadyInCart) {

    if (document.querySelector('.cart-item.first') != null) {
      document.querySelector('.cart-item.first').classList.remove('first');
    }
    if (document.querySelector('#cart__drawer_items .empty') != null)
    {
      document.querySelector('#cart__drawer_items .empty').remove();
      document.querySelector('#cart__drawer_items .cart-tools').classList.remove('hidden');
    }
    var drawerItemHtml = buildDrawerItemHtml(currentVariant, currentQty);
    document.querySelector('#cart__drawer_items').insertAdjacentHTML('afterbegin', drawerItemHtml);
    //updateTotalPrice();
  }
  updateTotalPrice();
  
}

var drawerItems = function () {
  // create an object that includes pertinent drawer items
  var cartItems = $(cartItemDiv).find('.cart-item');
  var cartItemsKvp = {};
  
  for (let i = 0; i < cartItems.length; i++) {
    var qtyItem = $(cartItems[i]).find('.cart-item-quantity-display');
    var dataKey = cartItems[i].dataset.key;
    var dataValue = $(qtyItem).val();
    cartItemsKvp[dataKey] = dataValue;

    totalItems += ($(qtyItem).val() * 1);
  }

  return cartItemsKvp;
}

var buildDrawerItemHtml = function (variantId, itemQty) {

  var dataVariantElement = document.querySelector('[data-variant-id="' + variantId + '"]');
  var productTitle = item.Name;
  var variantTitle = dataVariantElement.innerText.trim().split(' - $')[0];
  var itemUrl = item.URL;
  
  var itemColorElem = document.querySelector('input[type="radio"][name="option-1"]:checked');
  var itemColor = itemColorElem ? itemColorElem.value : '';  // If the element doesn't exist, use an empty string or any default value

                  // if the option order changes, the above could get funky
                  //variantTitle.substring(variantTitle.indexOf(' / ') + 3); // don't use this method for now
  
  var imgUrl;
  
  // If itemColor has a value, fetch the corresponding product image.
  if (itemColor) {
      imgUrl = document.querySelector('.product-thumbnails img[data-color="' + itemColor + '"]').src.replace("_50x50", "_100x100");
  } 
  // If itemColor doesn't have a value, fetch the default image (gift card).
  else {
      imgUrl = document.querySelectorAll('.product-thumbnails img')[0].src.replace("_50x50", "_100x100");
  }
  //var imgUrl = document.querySelector('img.active').src.replace("_50x50", "_100x100"); 
    //100x100 is the parameter // e.g. https://cdn.shopify.com/s/files/1/1065/5708/products/3176-530-ThistleDown_100x100.jpg?v=1673381860

  var itemPrice = toPrice(dataVariantElement.innerText.trim().split(' - $')[1]);
  var itemPriceDisplay = (itemPrice / 100).toFixed(2);

  var inventoryQty = $(dataVariantElement).data('inventory-available');// 
  var itemTotal = ((itemPrice * 1) * (itemQty * 1)/100).toFixed(2); 
  
  
  var divCartItem = 
  `      <div
          class="cart-item variant-${variantId} first"
          data-variant="${variantId}"
          data-title="${productTitle}"
          data-url="${itemUrl}">
          <div class="cart-item-product first">
            <a
              class="cart-image"
              href="${itemUrl}">
              <img
                src="${imgUrl}"
                alt="${productTitle}">
            </a>
  
            <div class="cart-item-product-wrap">
              <span class="cart-title">
                <a href="${itemUrl}">${productTitle}</a>
              </span>
              <span class="cart-variant">${variantTitle}</span>
  	        </div>
          </div>
          <div class="cart-item-price">
            <span class="money">$ ${itemPriceDisplay}</span>
          </div>
          <div
            class="cart-item-quantity" 
              data-max="${inventoryQty}">
            <input
              type="text"
              name="updates[]"
              class="input-field cart-item-quantity-display"
              value="${itemQty}" size="1" onfocus="getQtyInputOnFocus()" onblur="updateQtyInputs()">
            <button class="cart-item-decrease icon" data-update-qty>&#57364;</button>
            <button class="cart-item-increase icon" data-update-qty>&#57365;</button>
          </div>
          <div class="cart-item-total last">
            <span class="money">$ ${itemTotal}</span>
          </div>
          <div class="max-inventory hidden">
            <p>No further inventory is available</p>
          </div>
        </div>
  				`;
  return divCartItem;
}

var updateFreeShippingProgress = function (cartTotalInCents) { // receives value in cents
  var freeShipMessage;
  var freeShipProgress = 0.0;

  if (cartTotalInCents >= 5000) { // 5000 cents is $50
    freeShipMessage = "Congratulations! You've earned Free Shipping!";
    freeShipProgress = 100;
  } else {
    var differenceInCents = 5000 - cartTotalInCents; 
    freeShipMessage = "You're only $" + (differenceInCents / 100).toFixed(2) + " away from Free Shipping!"; // convert to dollars for display
    freeShipProgress = (cartTotalInCents / 50); // Since 5000 cents is 100%, cartTotalInCents is how many 2%?
  }

  document.querySelector('.drawer__free-shipping p').innerText = freeShipMessage;
  moveFreeShipping(freeShipProgress);
}

var currentWidth = 0;  // Global variable to keep track of the current width

function moveFreeShipping(freeShipProgress) {
  var elem = document.getElementById("drawer__free-shipping-bar");

  // Check if elem.style.width has a value and if it's in percentage format
  var hasStyleWidth = elem.style.width && elem.style.width.includes('%');
  
  // Use the global currentWidth if available; otherwise use elem.style.width
  // but only if it meets the criteria checked above
  var width = currentWidth ? currentWidth : (hasStyleWidth ? parseFloat(elem.style.width.replace('%', '')) : 0);
  
  var id = setInterval(frame, 10);

  function frame() {
    let difference = Math.abs(width - freeShipProgress);

    // Stop updating when the difference is negligible (e.g., less than 0.1%)
    if (difference < 0.1) {
      clearInterval(id);
      elem.style.width = freeShipProgress + '%';  // ensure the final width matches the target
      currentWidth = freeShipProgress;  // Update the global variable
    } else {
      let step = difference < 1 ? difference : 1;  // use smaller step if difference is less than 1
      if (freeShipProgress > width) {
        width += step;
      } else {
        width -= step;
      }
      elem.style.width = width + '%';
      currentWidth = width;  // Update the global variable
    }
  }
}




